// extracted by mini-css-extract-plugin
export default {"skelet":"MenuListSkelet_skelet--ex0","skeletShimmer":"MenuListSkelet_skeletShimmer--T4a","skeletBlock":"MenuListSkelet_skeletBlock--fib"};